import { withCompInfo } from '@wix/editor-elements-integrations'
import { SelectableContainerCss } from './SelectableContainer.types'
import _ from 'lodash'

export const css = withCompInfo<SelectableContainerCss, never>()([], (__, additionalData) => {
	return {
		'--input-content': _.get(additionalData, ['childData', 'childStyleProperties', 'inputContent'], ''),
	}
})
